<template>
<div>
  <el-container>
    <!--头部导航开始-->
    <el-header>
        <top-nav :index="'1'"></top-nav>
    </el-header>
    <!--头部导航结束-->
    <el-container :style="{height:hei+'px'}">
        <enk-nav></enk-nav>
        <!--子菜单（用户中心）结束-->
        <el-main class="main_bg">
            <router-view></router-view>
        </el-main>
    </el-container>

  </el-container>
</div>
</template>

<script>
import topnav from '@/components/topnav.vue'
import corenav from '@/components/corenav.vue';
export default {
    data() {
      return {
        activeIndex: '3',
        isCollapse: false,
        hei:window.innerHeight - 60
      };
    },
    created(){
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      checklabel:function(){

       console.log("ss");

       if(this.isCollapse){
        this.isCollapse=false
       }else{

        this.isCollapse=true
       }

      }
    },
    components:{
      'topNav':topnav,
      'enkNav':corenav,
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main.vue